// @ts-nocheck
// One-shot safety notice shown the FIRST time a reader enters listen
// mode on a given device. Shlomo asked for this in the listening
// redesign spec: people will be listening in the car, and we need a
// clear "audio only, no reading/writing" reminder before they get
// going.
//
// Dismissed permanently per device via localStorage. App.tsx mounts
// this component only when the flag is unset and listen mode is
// active.

import { useEffect } from "react";

export const DRIVING_NOTICE_KEY = "ei_audio_driving_dismissed";

// Has the reader already acknowledged the notice on this device?
// Used by App.tsx to decide whether to mount the modal at all.
export function isDrivingNoticeDismissed(): boolean {
  try {
    return window.localStorage.getItem(DRIVING_NOTICE_KEY) === "1";
  } catch {
    return false;
  }
}

type Props = {
  onDismiss: () => void;
};

export function DrivingNotice({ onDismiss }: Props) {
  // Persist the flag the moment we mount the modal so a reader who
  // closes the tab without explicitly clicking the button doesn't
  // get nagged on every future listen-mode entry. The explicit
  // "אישור" still triggers onDismiss to actually hide the modal.
  useEffect(() => {
    try {
      window.localStorage.setItem(DRIVING_NOTICE_KEY, "1");
    } catch {}
  }, []);

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="driving-notice-title"
      className="driving-notice-overlay"
      onClick={onDismiss}
    >
      <div
        className="driving-notice-card"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="driving-notice-icon" aria-hidden="true">🚗</div>
        <h2 id="driving-notice-title" className="driving-notice-title">
          בטיחות בנהיגה
        </h2>
        <p className="driving-notice-body">
          אם אתם נוהגים — <strong>האזנה בלבד</strong>.
          <br />
          אל תקראו ואל תכתבו תוך כדי נהיגה. זה מסוכן ולא חוקי.
        </p>
        <button
          type="button"
          className="driving-notice-btn"
          onClick={onDismiss}
          autoFocus
        >
          הבנתי, ממשיכים
        </button>
      </div>
    </div>
  );
}
